import React, { useEffect, useState } from "react";
import { TabContent, TabPane, Nav, NavItem, NavLink } from "reactstrap";
import classnames from "classnames";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import LeaderboardTable from "../../../Manager/Home/components/LeaderboardTable";
import { getLeaderboardLeaders } from "@/services/program/getLeaderboardLeaders";

const Leaderboards = ({ program, organization }) => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState(0);
  const [loading, setLoading] = useState(true);
  const [leaderboardLeaders, setLeaderboardLeaders] = useState([]);

  useEffect(() => {
    if (!organization?.id || !program?.id) {
      return;
    }

    setLoading(true);
    getLeaderboardLeaders(organization.id, program.id)
      .then((items) => {
        setLeaderboardLeaders(items || []);
        setLoading(false);
      })
      .catch(() => {
        setLeaderboardLeaders([]);
        setLoading(false);
      });
  }, [organization?.id, program?.id]);

  useEffect(() => {
    if (activeTab > Math.max(leaderboardLeaders.length - 1, 0)) {
      setActiveTab(0);
    }
  }, [activeTab, leaderboardLeaders.length]);

  const toggle = (tab) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
    }
  };

  if (loading) {
    return (
      <div className="leaderboards-panel leaderboards-panel--loading">
        <p className="leaderboards-panel__state">{t("loading")}</p>
      </div>
    );
  }

  if (leaderboardLeaders.length === 0) {
    return (
      <div className="leaderboards-panel leaderboards-panel--empty">
        <p className="leaderboards-panel__state">{t("no_activity_yet")}</p>
      </div>
    );
  }

  return (
    <div className="leaderboards leaderboards--participant">
      <div className="leaderboards-panel">
        {leaderboardLeaders.length > 1 && (
          <Nav tabs className="leaderboards-panel__tabs">
            {leaderboardLeaders.map((item, index) => (
              <NavItem key={item.id || index} className="leaderboards-panel__tab-item">
                <NavLink
                  className={classnames("leaderboards-panel__tab", {
                    active: activeTab === index,
                  })}
                  onClick={() => {
                    toggle(index);
                  }}
                >
                  {item.name}
                </NavLink>
              </NavItem>
            ))}
          </Nav>
        )}

        <TabContent activeTab={activeTab} className="leaderboards-panel__content">
          {leaderboardLeaders.map((item, index) => (
            <TabPane tabId={index} key={item.id || index}>
              <div className="leaderboards-panel__table">
                <LeaderboardTable id={item.id} leaderboard={item} />
              </div>
            </TabPane>
          ))}
        </TabContent>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  program: state.program,
  organization: state.organization,
});

export default connect(mapStateToProps)(Leaderboards);
